import * as React from "react";
import {AuthenticatedEntityTypeEnum} from "../../../../../model/user/AuthenticatedEntity";
import CreatorPresenterComponent from "./CreatorPresenterComponent";

interface IProps {
	value: {
		id: string;
		type: AuthenticatedEntityTypeEnum;
	}
}

export const CreatorPresenter: React.SFC<IProps> = (props) => {
	return (
		<CreatorPresenterComponent userId={props.value.id} type={props.value.type}/>
	);
};